import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How I kicked my caffeine habbit in 10 painful steps",
  "description": "",
  "published": "2009-10-07T00:00:00.000Z",
  "redirect_from": ["/blog/how-i-kicked-my-caffeine-habbit-in-10-painful-steps/swizec/764"],
  "categories": "Caffeine, food for thought, life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Caffeine_molecule.png"
          }}><figure parentName="a" {...{
              "className": "gatsby-resp-image-figure",
              "style": {
                "textAlign": "center",
                "fontStyle": "italic"
              }
            }}>{`
    `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "262px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "73.09417040358744%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'293\\'%20viewBox=\\'0%200%20400%20293\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M217%2019c-4%201-7%207-7%2011%200%206%206%2012%2011%2012%207%200%2010-1%2010-4%200-2%200-2-4-1-10%203-17-6-10-13%202-2%208-2%2012-1%202%201%202%201%202-1%200-4-8-5-14-3m20%2011c0%2010%200%2012%202%2012l1-5c0-6%200-6%207-5l6%201-1%204c0%205%200%205%203%205%202%200%202%200%202-11l-1-12c-2-2-4%200-4%203%200%206%200%206-6%206h-6v-5l-1-5c-2%200-2%202-2%2012m28-4c-1%203%200%203%203%203%204%201%206%204%202%205-3%201-3%204%200%205%204%202%203%205-2%206-5%200-6%201-3%203%206%204%2016-5%2011-10-2-1-2-2-1-4%202-3%201-6-1-8-3-1-9-2-9%200m67%2052c-4%201-9%205-10%209-3%209%208%2018%2018%2014%207-3%209-14%203-20-4-3-7-4-11-3M213%2088v7l-9%205a1236%201236%200%2001-28%2017c-2%202-6%201-27-6l-22-7c-1%202%202%204%206%205l4%201%205%201%205%202%2021%207c3%200%203%202%203%2031%200%2030%200%2029-6%2031l-4%201-5%202-4%201-8%202-1%201-9%203c-6%202-9%204-6%204l23-7%2021-7%205%203a414%20414%200%200141%2024c2%202%202%204%202%2022%200%2015%201%2020%202%2020l1-19v-19h3l2-1v20l1%2019%201-20v-21l12-7a937%20937%200%200122-14c6-4%200-2-9%203l-7%205-9%205c-15%209-14%209-25%202l-4-3-29-17-8-4v-59l10-6a1280%201280%200%200026-15c3-2%204-2%204%202l2%202c2%200%202-1%202-7%200-9%201-9%204-5%204%206%2010%2012%2012%2012s2-1%202-11-1-12-2-12c-2%200-2%201-2%208v8l-7-8c-9-10-11-10-11-1m115-3c-3%203-3%208%200%2011%205%205%2013%202%2014-6%202-7-9-11-14-5m-227%2019c0%2010%200%2011%202%2011s2-1%202-7l1-8%2012%2014%203%201c2%200%202%200%202-11s0-12-2-12-2%201-2%208v8l-7-8c-10-11-11-11-11%204m211-8a1059%201059%200%2000-34%2018l-4%202-6-3a424%20424%200%2000-28-16c-2%200-1%203%202%204l19%2010%2016%2010v19c0%2016%200%2019%202%2019l1-18v-18l4-2a557%20557%200%200026-17%20210%20210%200%2001-20%2011c-8%205-10%206-11%204-2-1-1-2%209-7a419%20419%200%200024-16M93%20127a517%20517%200%2001-15%2023%20523%20523%200%200015%2018%205913%205913%200%2001-12-20l5-6a296%20296%200%200115-24l-8%209m71%2023l1%2026%201-25-1-26c-1-1-1%208-1%2025m104%2026c0%2010%200%2011%202%2011s2-1%202-7l1-7%207%207c9%2010%2010%2010%2010-4%200-11%200-12-2-12s-2%201-2%208v8l-7-8c-10-11-11-11-11%204M99%20192l-1%2012v10h3c2%200%202%200%202-8v-8l7%208c10%2011%2011%2011%2011-3%200-12-1-15-3-12l-2%207v7l-7-7c-7-8-9-9-10-6m228%209c-12%207-3%2026%2012%2022l4-3c0-2%200-2-2-2-7%203-9%202-12-1-8-8%201-16%2012-13%202%201%202%201%202-1%200-4-10-5-16-2m22%200v22c1%202%203-1%203-5v-5h12v4c0%205%202%208%204%206%201-1%202-21%200-23-2-3-4%200-4%205%200%204-1%205-4%205-7%200-8%200-8-6%200-5-2-7-3-3M26%20244c-7%207-2%2019%209%2020%205%200%209-1%2010-4%200-2%200-2-2-2-10%203-15%201-15-7%201-6%205-9%2012-7%204%201%206%201%204-2%200-1-2-2-7-2-7%200-7%200-11%204m24-3l-1%2011c0%2011%200%2011%203%2011%202%200%202%200%202-4v-5h12v5c0%203%200%204%202%204s2-1%202-11c0-11%200-12-2-12s-2%201-2%205%200%204-6%204h-5l-1-4c0-4%200-5-2-5l-2%201m26%2011c-2%201-1%203%201%203%203-1%205%202%202%204l-2%202%202%202c4%202%202%206-3%204-2%200-2%200-2%202%201%202%207%203%209%200%202-2%203-6%201-8v-2c2-2%201-4-1-6s-6-3-7-1m143%206c-13%206-8%2024%206%2024%209%200%2014-10%2010-18-3-6-11-8-16-6m3%204c-9%201-8%2015%202%2015%203%200%205%200%206-2%205-6%200-14-8-13\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                    "srcSet": ["/static/7ef21b2e7d82f3ae0f901c04619ed99e/ca0a1/The-molecular-structure-of-caffeine4f6bfg.webp 223w", "/static/7ef21b2e7d82f3ae0f901c04619ed99e/55dc7/The-molecular-structure-of-caffeine4f6bfg.webp 262w"],
                    "sizes": "(max-width: 262px) 100vw, 262px",
                    "type": "image/webp"
                  }}></source>{`
          `}<source parentName="picture" {...{
                    "srcSet": ["/static/7ef21b2e7d82f3ae0f901c04619ed99e/e92b6/The-molecular-structure-of-caffeine4f6bfg.png 223w", "/static/7ef21b2e7d82f3ae0f901c04619ed99e/8ff13/The-molecular-structure-of-caffeine4f6bfg.png 262w"],
                    "sizes": "(max-width: 262px) 100vw, 262px",
                    "type": "image/png"
                  }}></source>{`
          `}<img parentName="picture" {...{
                    "className": "gatsby-resp-image-image",
                    "src": "/static/7ef21b2e7d82f3ae0f901c04619ed99e/8ff13/The-molecular-structure-of-caffeine4f6bfg.png",
                    "alt": "The molecular structure of caffeine",
                    "title": "The molecular structure of caffeine",
                    "loading": "lazy",
                    "style": {
                      "width": "100%",
                      "height": "100%",
                      "margin": "0",
                      "verticalAlign": "middle",
                      "position": "absolute",
                      "top": "0",
                      "left": "0"
                    }
                  }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
                "className": "gatsby-resp-image-figcaption"
              }}>{`The molecular structure of caffeine`}</figcaption>{`
  `}</figure></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Caffeine_molecule.png"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Hello, my name is Swizec and I drink `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Caffeine",
        "title": "Caffeine"
      }}>{`caffeine`}</a>{`. Lots of caffeine.`}</p>
    <p>{`"We love you Swizec, welcome to caffeinistas anonymous .."`}</p>
    <p>{`Yeah no, it didn't go quite like that, but it was close. At some point in my life I discovered that caffeine was awesome, not because it helped you stay up longer and wake up earlier, gawd it makes waking up hard doesn't it? It was because when I'm on caffeine I can think quicker and I like thinking quickly seeming as how I always stumble upon occasions when`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      